import moment from 'moment'

export default {
  install (Vue) {
    Vue.prototype.$formatDateTimeSecond = (str) => moment(str).format('YYYY-MM-DD HH:mm:ss')
    Vue.prototype.$formatDateTime = (str) => moment(str).format('YYYY-MM-DD HH:mm')
    Vue.prototype.$formatDate = (str) => moment(str).format('YYYY-MM-DD')
    Vue.prototype.$formatHM = (str) => moment(str).format('HH:mm')
  }
}



// WEBPACK FOOTER //
// ./src/utils/common.js